<template>
  <div class="module-list-container">
    <div class="list-header">
      <h1>Módulos</h1>
    </div>

    <div v-if="loading" class="loading-container">
      <div class="loading-spinner"></div>
      <p>Carregando módulos...</p>
    </div>

    <div v-else-if="modules.length === 0" class="empty-state">
      <div class="empty-icon">
        <i class="fas fa-puzzle-piece"></i>
      </div>
      <h2>Nenhum módulo encontrado</h2>
      <p>Os módulos são os componentes básicos para construir seus pipelines.</p>
    </div>

    <div v-else class="module-grid">
      <div v-for="module in modules" :key="module.id" class="module-card">
        <div class="module-icon" :class="'module-type-' + module.type">
          <i :class="getModuleIcon(module.type)"></i>
        </div>
        <div class="module-content">
          <h2 class="module-name">{{ module.name }}</h2>
          <p class="module-description">{{ module.description || 'Sem descrição' }}</p>
          <div class="module-type">
            <span class="type-badge">{{ module.type }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModuleList',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    modules() {
      return this.$store.getters.getModules || []
    }
  },
  methods: {
    async fetchModules() {
      this.loading = true
      try {
        await this.$store.dispatch('fetchModules')
      } catch (error) {
        console.error('Erro ao buscar módulos:', error)
        this.$toast.error('Erro ao carregar módulos')
      } finally {
        this.loading = false
      }
    },
    
    getModuleIcon(type) {
      const icons = {
        'uploadData': 'fas fa-upload',
        'transform': 'fas fa-exchange-alt',
        'dataQuality': 'fas fa-check-circle',
        'dbConnection': 'fas fa-database',
        'filter': 'fas fa-filter',
        'join': 'fas fa-link',
        'export': 'fas fa-download',
        'notification': 'fas fa-bell'
      };
      
      return icons[type] || 'fas fa-cube';
    }
  },
  created() {
    this.fetchModules()
  }
}
</script>

<style scoped>
.module-list-container {
  padding: 2rem;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.list-header h1 {
  margin: 0;
  color: #1e293b;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem;
  text-align: center;
}

.empty-icon {
  font-size: 3rem;
  color: #cbd5e1;
  margin-bottom: 1rem;
}

.empty-state h2 {
  margin: 0 0 0.5rem 0;
  color: #1e293b;
}

.empty-state p {
  margin: 0 0 1.5rem 0;
  color: #64748b;
  max-width: 400px;
}

.module-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

.module-card {
  display: flex;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;
}

.module-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.module-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  color: white;
  font-size: 1.5rem;
}

.module-content {
  flex: 1;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
}

.module-name {
  margin: 0 0 0.5rem 0;
  font-size: 1.25rem;
  color: #1e293b;
}

.module-description {
  margin: 0 0 1rem 0;
  color: #64748b;
  font-size: 0.875rem;
  flex: 1;
}

.module-type {
  display: flex;
  justify-content: flex-end;
}

.type-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  background-color: #f1f5f9;
  color: #475569;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
}

/* Cores dos módulos */
.module-type-uploadData {
  background-color: #3b82f6;
}

.module-type-transform {
  background-color: #8b5cf6;
}

.module-type-dataQuality {
  background-color: #10b981;
}

.module-type-dbConnection {
  background-color: #f59e0b;
}

.module-type-filter {
  background-color: #6366f1;
}

.module-type-join {
  background-color: #ec4899;
}

.module-type-export {
  background-color: #14b8a6;
}

.module-type-notification {
  background-color: #f97316;
}
</style>
